// SPDX-FileCopyrightText: Copyright (c) 2025-2026 provide.io llc. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
const LOG_LEVEL_ORDER = {
    TRACE: 0,
    DEBUG: 1,
    INFO: 2,
    WARNING: 3,
    WARN: 3,
    ERROR: 4,
    CRITICAL: 5,
};
// Stryker disable next-line StringLiteral: initial value is overwritten by resetConsentForTests before any test observes it
let _consentLevel = 'FULL';
export function setConsentLevel(level) {
    _consentLevel = level;
}
export function getConsentLevel() {
    return _consentLevel;
}
export function shouldAllow(signal, logLevel) {
    const level = _consentLevel;
    if (level === 'FULL')
        return true;
    if (level === 'NONE')
        return false;
    if (level === 'FUNCTIONAL') {
        if (signal === 'logs') {
            // Stryker disable next-line StringLiteral: equivalent — any non-existent key in LOG_LEVEL_ORDER falls back to 0 via ?? 0
            const order = LOG_LEVEL_ORDER[(logLevel ?? '').toUpperCase()] ?? 0;
            return order >= LOG_LEVEL_ORDER['WARNING'];
        }
        if (signal === 'context')
            return false;
        return true;
    }
    // MINIMAL
    if (signal === 'logs') {
        // Stryker disable next-line StringLiteral: equivalent — any non-existent key in LOG_LEVEL_ORDER falls back to 0 via ?? 0
        const order = LOG_LEVEL_ORDER[(logLevel ?? '').toUpperCase()] ?? 0;
        return order >= LOG_LEVEL_ORDER['ERROR'];
    }
    return false;
}
export function loadConsentFromEnv() {
    const raw = (process.env['PROVIDE_CONSENT_LEVEL'] ?? 'FULL').trim().toUpperCase();
    const valid = ['FULL', 'FUNCTIONAL', 'MINIMAL', 'NONE'];
    if (valid.includes(raw)) {
        _consentLevel = raw;
    }
}
export function resetConsentForTests() {
    _consentLevel = 'FULL';
}
